<template>

  <md-autocomplete v-model="selectedItem"
                   @md-changed="handleTermChanged"
                   @md-selected="handleItemSelected"
                   @md-opened="handleOpened"
                   :md-options="items"
                   :disabled="disabled"
                   :createOption="createOption" >
    <label v-if="label">{{label}}</label>

    <template slot="md-autocomplete-item" slot-scope="{ item, term }">
      <md-tooltip md-delay="50">{{ item.name }} ({{item.id}})</md-tooltip>
      <template v-if="displayType == 'idOnly'">
        <md-highlight-text :md-term="term">{{item.id}}</md-highlight-text>
      </template>
      <template v-else>
         <template v-if="displayType == 'nameOnly'">
           <md-highlight-text :md-term="term">{{item.name}}</md-highlight-text>
         </template>
         <template v-else>
           <template v-if="reverse">
             <md-highlight-text :md-term="term">{{ item.id }} ({{item.name}})</md-highlight-text>
           </template>
           <template v-else>
             <md-highlight-text :md-term="term">{{ item.name }} ({{item.id}})</md-highlight-text>
           </template>
         </template>
      </template>
     
    </template>

    <template slot="md-autocomplete-empty" slot-scope="{ term }">
      <template v-if="createOption">
       
      <a @click="noop()">Create a new</a> one 
      </template>
      <template v-else>
        No item matching "{{ term }}" were found.
     
      </template>
    </template>

  </md-autocomplete>

</template>

<script>
  import { mapGetters } from 'vuex';

  export default {
    props: {
      label: String,
      group: String,
      onItemChanged: Function,
      initValue: String,
      initValueId: String,
      watchValueId: String,
      preparedOptions: Array,
      displayType: String,
      selectType: String,
      lazySearch: Boolean,
      disabled: Boolean,
      createOption: Boolean,
      onCreation: Function,
      reverse: Boolean,
    },
    data: () => ({
      selectedItem: '',
      items: [],
    }),
    computed: {
      ...mapGetters([
        'getMasterDataAsSelectOptionByGroup',
        'getMasterDataName',
      ]),
      getOptions() {
        if (this.preparedOptions) {
          console.log(`this.preparedOptions=${JSON.stringify(this.preparedOptions)}`);
          return this.preparedOptions;
        }
        return this.getMasterDataAsSelectOptionByGroup(this.group);
      },
    },
    watch: {
      selectedItem(item) {
        if (item && _.isObject(item)) {
          if (this.displayType === 'idOnly') {
            this.selectedItem = item.id;
          } else if (this.displayType === 'nameOnly') {
            this.selectedItem = item.name;
          } else {
            this.selectedItem = `${item.name} (${item.id})`;
          }
        }
        if (!item || item === '') {
          this.onItemChanged(null, null,  null, null, null, null);
        }
      },
      watchValueId(idToWatch) {
        if (idToWatch) {
          this.selectedItem = _(this.getOptions)
            .find(it => it.id === idToWatch ) || '';
        } else {
          this.selectedItem = "";
        }
      },
      getOptions() {
        if (!this.lazySearch) {
          this.items = this.getOptions;
        }
      },
      preparedOptions() {
        this.init();
      },
    },
    mounted() {
      this.init();
    },
    methods: {
      init() {
        this.$nextTick(() => {
          if (this.initValue) {
            this.selectedItem = this.initValue;
          }
          if (this.initValueId) {
            this.selectedItem = _(this.getOptions)
              .find(it => it.id === this.initValueId) || '';
            console.log(`initValueId=${this.initValueId} selectedItem=${this.selectedItem}, options=${JSON.stringify(this.getOptions)}`);
          }
          if (!this.lazySearch) {
            this.items = this.getOptions;
          }
        });
      },

      noop () {
        this.onCreation()
        
      },


      clear() {
        this.selectedItem = '';
      },
      handleTermChanged(term) {
        console.log(`handleTermChanged, term=${term}`);
        if (this.selectedItem && term !== this.selectedItem) {
          this.selectedItem = '';
        }
        if (this.lazySearch) {
          this.items = new Promise((resolve) => {
            if (term.length > 1) {
              const results = _(this.getOptions)
                .chain()
                .filter(it => it.id.indexOf(term) > -1 || it.name.indexOf(term) > -1)
                .take(10)
                .value();
              resolve(results);
            } else {
              resolve([]);
            }
          });
        }
      },
      handleItemSelected(item) {
        if (this.onItemChanged && _.isFunction(this.onItemChanged)) {
          console.log('In handle select');
          console.log(item);
          this.onItemChanged(item.id, item.name, item.unit, item.weight, item.plate, item.trail, item.gradeUpgrade);
        }
      },
      handleOpened() {
        this.selectedItem = '';
      },
    },
  };
</script>
